import React from 'react';

import AboutPage from './about_page';

function App() {
  return <AboutPage/>;
}

export default App;
